.modal {
  --modal-margin: 48px;

  :global(.ant-modal-close) {
    display: none;
  }

  .container {
    padding: 0;
  }

  .body {
    border-bottom-right-radius: var(--rc-theme-border-radius-lg);
    border-bottom-left-radius: var(--rc-theme-border-radius-lg);
  }

  .header {
    margin-bottom: 0;
  }

  .container:has(.scrollable-content) {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 2 * var(--modal-margin));
  }

  .body:has(.scrollable-content) {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
  }

  &:has(.hug-content) {
    margin-top: var(--modal-margin);
    margin-bottom: var(--modal-margin);
  }

  .full-width-content {
    width: calc(100% + 2 * var(--rc-theme-spacing-lg));
    margin-right: calc(-1 * var(--rc-theme-spacing-lg));
    margin-left: calc(-1 * var(--rc-theme-spacing-lg));
  }
}
